import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import type { IBriefingPage, IResourceModel } from '@/shared/model/briefing-widget.model';
import GoCardCompanyVer2 from '@/shared/cards/company/go-company-card.vue';
import { checkIsGuestAccount } from '@/util/guest-util';
import { namespace } from 'vuex-class';
import UserMyPageService from '@/service/userMyPage.service';
import BriefingService from '@/service/briefing.service';

const appStoreState = namespace('appStore');
const briefingStore = namespace('briefingStore');

@Component({
  components: {
    'company-card-v2': GoCardCompanyVer2,
  },
})
export default class BriefingCardFeaturedCompaniesComponent extends Vue {
  @Prop(Array) resourceItems: IResourceModel[] | [];
  @Prop(Boolean) readonly isHiddenRemove: boolean | false;

  @Inject('userMyPageService')
  private userMyPageService: () => UserMyPageService;
  @Inject('briefingService')
  private briefingService: () => BriefingService;

  data() {
    return {
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        loop: false,
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          0: {
            slidesPerView: 1,
          },
        },
      },
    };
  }
  @briefingStore.Mutation
  public setSelectedResource!: (payload: IResourceModel) => void;
  @appStoreState.Mutation
  public setShowDetailReport!: (b: boolean) => void;
  @appStoreState.Mutation
  public setShowDetailTopic!: (b: boolean) => void;
  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;
  @appStoreState.Mutation
  public setShowDetailArticles!: (b: boolean) => void;
  @briefingStore.Mutation
  public updateAddingResources!: (payload: IResourceModel) => void;
  @briefingStore.Mutation
  public updateTotalResources!: (payload: number) => void;

  viewDetail(item: IResourceModel) {
    this.setSelectedResource(item);
    const language = this.$store.getters.currentLanguage ? this.$store.getters.currentLanguage : '';
    switch (item.type) {
      case 'REPORT':
        this.setShowDetailReport(true);
        this.userMyPageService().saveUserActivitiesOpenReportDetail(item.docId, language);
        break;
      case 'TOPIC_SUMMARY':
        this.setShowDetailTopic(true);
        break;
      case 'VIDEO':
        if (this.getSelectedResource?.isShowSourceReference) {
          window.open(item.url, '_blank');
        } else {
          this.setShowDetailArticles(true);
        }
        break;
      default:
        this.setShowDetailArticles(true);
        break;
    }
  }

  toggle2Resource(item: IResourceModel, index: number) {
    if (checkIsGuestAccount(true)) {
      return;
    }

    Vue.set(this.resourceItems[index], 'updatingBookmark', true);
    const toggleBookmark = !item.isBookmarked;
    const requestPromise = toggleBookmark
      ? this.briefingService().saveUserResource(Date.now(), item.type === 'VIDEO' ? 'DISCOVERY' : item.type, item.originParentDocDetail)
      : this.briefingService().unSaveUserResource(Date.now(), item.docId);
    requestPromise
      .then(response => {
        Vue.set(this.resourceItems[index], 'isBookmarked', toggleBookmark);
        if (this.isHiddenRemove && !toggleBookmark) {
          this.resourceItems.splice(index, 1);
        }

        const updatedResource = {
          ...item,
          updatingBookmark: false,
          isBookmarked: toggleBookmark,
        };

        const isOwnerResourceItem = item.owner_user_key === this.$store.getters?.userIdentity?.id;
        if (isOwnerResourceItem) {
          updatedResource.userProfile = {
            userKey: item.owner_user_key || this.$store.getters?.userIdentity?.id,
            lastName: item.userProfile?.lastName || this.$store.getters?.userIdentity?.lastName,
            imageUrl: item.userProfile?.imageUrl || this.$store.getters?.userIdentity?.imageUrl,
          };
        }

        this.updateAddingResources(updatedResource);
        this.updateTotalResources(toggleBookmark ? 1 : -1);
      })
      .finally(() => {
        Vue.set(this.resourceItems[index], 'updatingBookmark', false);
      });
  }
}
